import { PrimaryInputFieldType } from "../components/Fields/PrimaryInputFieldType";

export const DOCUMENT_TYPES = [
  {
    id: 1,
    name: "Surat Keterangan Sakit",
    value: "SURAT_SAKIT",
  },
  {
    id: 2,
    name: "Surat Rujukan",
    value: "SURAT_RUJUKAN",
  },

  // {
  //   id: 3,
  //   name: "Formulir Persetujuan",
  //   value: "FORM_PERSETUJUAN",
  // },
  {
    id: 3,
    name: "Formulir Persetujuan Generik",
    value: "FORM_GENERIK",
  },
  {
    id: 4,
    name: "Formulir Persetujuan Detail",
    value: "FORM_DETAIL",
  },
];
export const DOCUMENT_FORM_ENUM = Object.freeze({
  PATIENT_NAME: "patientName",
  DOB: "dob",
  HOME_ADDRESS: "homeAddress",
  GENDER: "gender",
  EXAMINATION_DATE: "examinationDate",
  DOCUMENT_TYPE: "documentType",
  START_DATE: "startDate",
  END_DATE: "endDate",
  DOCTOR_NAME: "doctorName",
  INSTITUTION_NAME: "institutionName",
  DOCTOR_NOTE: "doctorNote",
});
export const CREATE_DOCUMENT_FORM_DATA = [
  {
    name: DOCUMENT_FORM_ENUM.PATIENT_NAME,
    placeholder: "Nama Pasien",
    type: PrimaryInputFieldType.DROPDOWN,
    required: true,
    readOnly: true,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.DOB,
    placeholder: "Tanggal Lahir",
    type: PrimaryInputFieldType.DATE,
    required: true,
    readOnly: true,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.HOME_ADDRESS,
    placeholder: "Alamat",
    type: PrimaryInputFieldType.TEXT,
    required: true,
    readOnly: true,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.GENDER,
    placeholder: "Jenis Kelamin",
    type: PrimaryInputFieldType.TEXT,
    required: true,
    readOnly: true,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.EXAMINATION_DATE,
    placeholder: "Tanggal Pemeriksaan",
    type: "date",
    required: true,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.DOCUMENT_TYPE,
    placeholder: "Jenis Dokumen",
    type: PrimaryInputFieldType.DROPDOWN,
    required: true,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.START_DATE,
    placeholder: "Tanggal Mulai",
    type: PrimaryInputFieldType.DATE,
    required: false,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: true,
  },
  {
    name: DOCUMENT_FORM_ENUM.END_DATE,
    placeholder: "Tanggal Selesai",
    type: PrimaryInputFieldType.DATE,
    required: false,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: true,
  },
  {
    name: DOCUMENT_FORM_ENUM.DOCTOR_NAME,
    placeholder: "Nama Dokter",
    type: PrimaryInputFieldType.DROPDOWN,
    required: true,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: false,
  },
  {
    name: DOCUMENT_FORM_ENUM.INSTITUTION_NAME,
    placeholder: "Nama Institusi",
    type: PrimaryInputFieldType.TEXT,
    required: false,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: true,
  },
  {
    name: DOCUMENT_FORM_ENUM.DOCTOR_NOTE,
    placeholder: "Catatan Dokter",
    type: PrimaryInputFieldType.TEXTAREA,
    required: false,
    readOnly: false,
    value: "",
    maxLength: 99999,
    hidden: true,
  },
];
